import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=b551ae48&scoped=true"
import script from "./GalleryEdit.vue?vue&type=script&lang=js"
export * from "./GalleryEdit.vue?vue&type=script&lang=js"
import style0 from "./GalleryEdit.vue?vue&type=style&index=0&id=b551ae48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b551ae48",
  null
  
)

export default component.exports